module.exports = __webpack_public_path__ + "static/49-img-1-396b3730be1109b9823a3cadb552a27f.png";